module.exports = __webpack_public_path__ + "img/sprinkle-29.038d5a89.jpg";